<template>
    <div>
        <myPage :max_flag="true">
            <div class="pd-left10 pd-bottom5" slot="header">
                <div class="flex-box nopadding wrap">
                    <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                        <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                        <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                    </el-button-group>
                    <div class="f-bd f14 text-nowrap">账期{{$t('x_mh')}}</div>
                    <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                    <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
                </div>
                <div class="mg-top5 mg-bottom5">
                    <myEcharsCol :rows="chart_data.rows" :line_value_key="chart_data.line_value_key" height="250px"
                                 :name_key="chart_data.name_key" :value_key="chart_data.value_key"></myEcharsCol>
                </div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" class="fillw" height="100%">
                    <el-table-column fixed :label="listHeader.date_no" width="110px">
                        <el-table-column label-class-name="f-red pd-top0" width="110px">
                            <div slot-scope="scope" slot="header">合计</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.date_no}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.start_order_qty" width="100px">
                        <div class="f-bd" slot-scope="scope">{{scope.row.start_order_qty * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.start_goods_amt" width="100px">
                        <div class="f-bd" slot-scope="scope">{{scope.row.start_goods_amt * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.start_guest_cost_amt" width="100px">
                        <div class="f-bd" slot-scope="scope">{{scope.row.start_guest_cost_amt * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.start_cost_amt" width="100px">
                        <div class="f-bd" slot-scope="scope">{{scope.row.start_cost_amt * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_order_qty">
                        <el-table-column label-class-name="f-red pd-top0" width="100px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.mv_order_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_order_qty * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" width="100px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.mv_goods_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_guest_cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" width="100px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.mv_guest_cost_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_guest_cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" width="100px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.mv_cost_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.fail_order_qty">
                        <el-table-column label-class-name="f-red pd-top0" width="100px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.fail_order_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.fail_order_qty * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.fail_goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" width="100px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.fail_goods_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.fail_goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.wait_order_qty">
                        <el-table-column label-class-name="f-red pd-top0" width="100px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.wait_order_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.wait_order_qty * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.wait_goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" width="120px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.wait_goods_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.wait_goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.end_order_qty" width="100px">
                        <div class="f-bd" slot-scope="scope">{{scope.row.end_order_qty * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.end_goods_amt" width="100px">
                        <div class="f-bd" slot-scope="scope">{{scope.row.end_goods_amt * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.end_guest_cost_amt" width="100px">
                        <div class="f-bd" slot-scope="scope">{{scope.row.end_guest_cost_amt * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.end_cost_amt" width="100px">
                        <div class="f-bd" slot-scope="scope">{{scope.row.end_cost_amt * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.upd_time" prop="upd_time" width="150px"></el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
    </div>
</template>

<script>
import myPager from '../../../components/myPager'
import myDatePicker from "../../../components/myDatePicker";
import myEcharsCol from "../../../components/myEcharsCol";
import excel from '../../../utils/excel'
export default {
    name:'report-day',
    components:{
        myPager,
        myDatePicker,
        myEcharsCol
    },
    data: function(){
        const listHeader = {
            date_no: '账期',
            start_order_qty: '期初订单量',
            start_goods_amt: '订单金额',
            start_guest_cost_amt: '客户结算价',
            start_cost_amt: '供应商结算价',
            mv_order_qty: '本期订单量',
            mv_goods_amt: '订单金额',
            mv_guest_cost_amt: '客户结算价',
            mv_cost_amt: '供应商结算价',
            fail_order_qty: '失败订单量',
            fail_goods_amt: '失败订单金额',
            wait_order_qty: '未完成订单量',
            wait_goods_amt: '未完成订单金额',
            end_order_qty: '期末订单量',
            end_goods_amt: '订单金额',
            end_guest_cost_amt: '客户结算价',
            end_cost_amt: '供应商结算价',
            upd_time: '结算时间'
        }
        return{
            relist: false,
            search:{
                search_url: 'report-day/list',
                datearea_id:5,//如果大于0 mounted 要删除date_fr date_to
                date_fr: '',
                date_to: '',
                page: 1,
                pageSize: 0,
                limit:'30'
            },
            listHeader,
            listData:[],
            totalData: {
                total: 0,//总行数
                sum:{}
            },
            chart_data: {
                value_key:'mv_goods_amt',
                name_key:'date_no',
                line_value_key:'avg_goods_amt',
                rows: [],
            },
        }
    },
    activated:function(){
        this.$base.setMenuOpens();
    },
    mounted:function(){
        this.$base.setMenuOpens();
        this.$base.listPageInit(this,()=>{
            this.list();
        });
    },
    methods: {
        onDateChange: function(data){
            this.search.date_fr = data[0];
            this.search.date_to = data[1];
        },
        onPagerChange: function () {
            this.list(true);
        },
        onLimitChange: function (limit) {
            this.search.limit = limit;
            this.list();
        },
        getChartData: function () {
            this.$base.showLoading();
            this.$request.sendPost("report-day/get-chart-data",this.search,(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.chart_data.rows = data.list;
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        list: function (change_page) {
            if (!change_page) {
                this.getChartData();
            }
            this.$base.list(this, change_page);
        },
        exportExcel: function(){
            // this.$base.exportExcel(this);
            excel.exportExcel(this);
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/report/day/list.vue